import { styled } from '@mui/material/styles';

import IconButton from "@mui/material/IconButton";

const StyledIconButton = styled(IconButton)(
    ({ theme, color }) => ({
        '& .MuiSvgIcon-root': {
            color: theme.palette.text[color] || 'inherit'
        },
    })
);

export default StyledIconButton;
